import {
  LOOP_CHROME_OFFSET,
  LOOP_LANDSCAPE_MAX_WIDTH,
  LOOP_LANDSCAPE_META_RESERVE,
  LOOP_PORTRAIT_MAX_WIDTH,
  LOOP_PORTRAIT_MIN_HEIGHT,
} from '@/constants/contentFeed';

// Sizing shared by every centre-stage surface — the portrait reel, the article's
// companion image and the post card — so all three occupy an identically sized frame and
// the loop does not resize as you move between content types.
//
// `dvh` rather than `vh`: on mobile the latter includes the collapsing browser chrome, so
// the media would overshoot and force a scroll on every load.
export const PORTRAIT_FRAME_HEIGHT = `calc(100dvh - ${LOOP_CHROME_OFFSET}px)`;

export const PORTRAIT_FRAME_SIZING = {
  flexShrink: 0,
  width: { base: '100%', md: 'auto' },
  height: { base: 'auto', md: PORTRAIT_FRAME_HEIGHT },
  minHeight: { base: 'auto', md: LOOP_PORTRAIT_MIN_HEIGHT },
  maxWidth: { base: '100%', md: LOOP_PORTRAIT_MAX_WIDTH },
} as const;

// Landscape width is capped by BOTH the design width and whatever the viewport height
// allows once the video's own aspect ratio is accounted for — so on a short window the
// video shrinks instead of pushing its own attribution off-screen. Applied to the whole
// column so the text underneath always lines up with the video's edges.
export const getLandscapeWidth = (ratio: number) =>
  `min(${LOOP_LANDSCAPE_MAX_WIDTH}px, calc((100dvh - ${LOOP_CHROME_OFFSET + LOOP_LANDSCAPE_META_RESERVE}px) * ${ratio}))`;
